import React from 'react';

import { CheckedIcon } from 'assets/images';
import { LOAN_OPTIONS_NAMES } from 'prequalificationV2/components/Offers/offers.constants';
import styles from 'prequalificationV2/pages/Dashboard/steps/AcceptOffer/ManualOffers/AcceptOneTermOffer/LoanOfferOptions/LoanOfferOptions.module.scss';

const LoanOfferOptions = () => {
  return (
    <div className={styles.loanOptionsContainer}>
      {LOAN_OPTIONS_NAMES.map((optionName) => (
        <div key={optionName} className={styles.loanOptionsRow}>
          <CheckedIcon className={styles.checkedIcon} />
          <div>{optionName}</div>
        </div>
      ))}
    </div>
  );
};

export default LoanOfferOptions;
